import { Button, Modal, ModalHeader } from "modules/common";
import React, { useState } from "react";
import { downloadUserManual } from "services/documents";
import "./UserSupportModal.css";

interface Props {
  isVisible: boolean;
  toggleModal: () => void;
}

const SUPPORT_MAIL = "pomoc@mps.hr";

export const UserSupportModal: React.FC<Props> = ({ isVisible, toggleModal }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    try {
      setIsDownloading(true);
      await downloadUserManual();
    } catch (error) {
      console.error("Error downloading user manual:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Modal
      isActive={isVisible}
      onClose={toggleModal}
      modalHeader={<ModalHeader onClose={toggleModal} title="Korisnička podrška" isLoading={false} />}
    >
      <div className="user-support-modal-content">
        <div className="user-support-modal-section">
          <p><strong>Radno vrijeme korisničke podrške:</strong></p>
          <p>Svaki radni dan 9h-17h.</p>
        </div>
        <div className="user-support-modal-section">
          <p><strong>Kontakt mail:</strong></p>
          <a href={`mailto:${SUPPORT_MAIL}`}>{SUPPORT_MAIL}</a>
        </div>
        <div className="user-support-modal-section">
          <p><strong>Preuzimanje korisničkih uputa</strong></p>
          <div className="user-support-button-container">
            <Button 
              type="button" 
              size="small" 
              variant="primary"
              onClick={handleDownload}
              disabled={isDownloading}
            >
              {isDownloading ? "Preuzimanje..." : "Preuzmi"}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
